import Image from 'next/image';
import sfv_network from '@/assets/images/logos/san_fernando_valley_network_logo.png';
import aces_la_network from '@/assets/images/logos/aces/aces-la-mark-full-color-rgb@144ppi50px.png';
import test_thrive from '@/assets/images/verified_checkbox.png';
import referral_partners from '@/assets/images/logos/clr/partner-icon.png';
import ysppp_network from '@/assets/images/logos/ysppp_clr.png';
import ventura_211_network from '@/assets/images/logos/clr/ventura-211-logo.png';
import classes from './CLRIcon.module.scss';

// keys here should match the "slug" from the referral network definition, with - replaced with _
const CLR_ICONS = {
  sfv_network,
  aces_la_network,
  test_thrive,
  referral_partners,
  ysppp_network,
  ventura_211_network
};

const CLR_STYLES = {
  test_thrive: {
    filter: 'hue-rotate(125deg)'
  }
};

const CLRIcon = ({ orgNetwork, orgNetworkId, withNetworkName = true }) => {
  // check that we have the `orgNetwork` api, and that the network id is defined (id >= 0)
  if (!orgNetwork || (!orgNetworkId && orgNetworkId !== 0)) {
    return null;
  }

  // a network id will be "invalid" here when an org has been removed from a network,
  // but has existing CLRs in that network
  if (!orgNetwork.any.isValidNetworkId(orgNetworkId)) {
    return null;
  }

  const slug = orgNetwork.slug(orgNetworkId)?.replace(/-/g, '_');

  const logoSrc = CLR_ICONS[slug];
  const logoStyle = CLR_STYLES[slug] || {};
  const networkName = orgNetwork.name(orgNetworkId);

  const logo = <Image src={logoSrc} width={15} height={15} alt={networkName} style={logoStyle} />;

  if (!withNetworkName) return logo;

  return (
    <span className={classes.closedLoopReferral}>
      {logo} {networkName}
    </span>
  );
};

export default CLRIcon;
